module.exports = __webpack_public_path__ + "static/media/aws-certified-developer-associate.9c2023d3.png";